import React, { useState } from "react";
import { constants } from "../utils/constants";
import { MdErrorOutline } from "react-icons/md";
import { cn } from "../utils/cn";
import CustomSelect from "./custom-select";
import { formatUrl } from "../utils/urlFormatter";

const primaryButton =
  "bg-zinc-700 hover:bg-zinc-800 transition-all ease-in-out duration-200 max-[350px]:min-w-full max-w-[150px] h-[48px] w-[120px] flex items-center justify-center my-2 border border-transparent text-white rounded-md text-base font-mono font-semibold";
const secondaryButton =
  "bg-transparent hover:bg-zinc-800 transition-all ease-in-out duration-200 max-[350px]:min-w-full max-w-[150px] h-[48px] w-[120px] flex items-center justify-center my-2 border border-zinc-800 text-white py-4 px-10 rounded-md text-base font-mono font-semibold";

const ModalBox = (props) => {
  const {
    showModal,
    props: propData,
    handleClose,
    handleCreateAndEdit,
    handleDelete,
    handleDeleteGroup,
    setError,
    error,
    isModalLoading,
    handleCreateAndEditGroupName,
    groups = [],
  } = props;
  const { action, groupId, groupName, bookmark } = propData;

  if (showModal)
    return (
      <div className="w-full h-screen bg-zinc-950/20 mx-auto p-5 absolute flex justify-center items-center top-0 left-0 right-0 bottom-0 z-[9999] ">
        <div className="w-full flex justify-center items-center"> 
          <div
            className={cn(
              "w-full max-w-[450px] bg-zinc-900 rounded-md mx-auto pt-5 border border-dashed border-zinc-700",
              action === constants.ACTION_DELETE_ITEM && "max-w-[450px]",
              (action === constants.ACTION_ADD_ITEM ||
                action === constants.ACTION_EDIT_ITEM) &&
                "max-w-[450px]"
            )}
          >
            <h1 className="text-[22px] md:text-[24px] text-light-white font-bold tracking-wide capitalize pb-3 text-center px-2 ">
              {constants.MODAL_TITLE[action]}
            </h1>
            {/* for add bookmark and edit bookmark */}
            {(action === constants.ACTION_ADD_ITEM ||
              action === constants.ACTION_EDIT_ITEM) && (
              <CreateAndEditBookmark
                groupName={groupName}
                name={bookmark?.title}
                link={bookmark?.url}
                groupId={groupId}
                id={bookmark?.id}
                handleClose={handleClose}
                handleCreateAndEdit={handleCreateAndEdit}
                action={action}
                setError={setError}
                error={error}
                isModalLoading={isModalLoading}
                groups={groups}
              />
            )}
            {/* delete bookmark */}
            {action === constants.ACTION_DELETE_ITEM && (
              <DeleteConfirmation
                name={bookmark?.title}
                link={bookmark?.url}
                groupId={groupId}
                id={bookmark?.id}
                handleClose={handleClose}
                handleDelete={handleDelete}
                action={action}
                setError={setError}
                error={error}
                isModalLoading={isModalLoading}
              />
            )}

            {(action === constants.ACTION_EDIT_GROUP_NAME ||
              action === constants.ACTION_ADD_GROUP) && (
              <CreateAndEditGroupName
                title={groupName || ""}
                groupId={groupId || ""}
                handleClose={handleClose}
                handleCreateAndEditGroupName={handleCreateAndEditGroupName}
                action={action}
                setError={setError}
                error={error}
                isModalLoading={isModalLoading}
              />
            )}

            {/* delete group */}
            {action === constants.ACTION_DELETE_GROUP && (
              <DeleteGroupConfirmation
                groupName={groupName}
                groupId={groupId}
                handleClose={handleClose}
                handleDeleteGroup={handleDeleteGroup}
                action={action}
                setError={setError}
                error={error}
                isModalLoading={isModalLoading}
              />
            )}
          </div>
        </div>
      </div>
    );
};

export default ModalBox;

const DeleteConfirmation = ({
  groupId,
  name = "",
  id = "",
  handleClose,
  handleDelete,
  action,
  setError,
  error,
  isModalLoading,
}) => {
  const [bookmarkName, setBookmarkName] = useState("");

  const handleChange = (e) => {
    error !== null && setError(null);
    setBookmarkName(e.target.value);
  };

  const handleSubmit = () => {
    setError(null);
    if (bookmarkName.trim() !== "" && bookmarkName.trim() === name) {
      handleDelete(action, groupId, id);
    } else {
      setError(constants.ALL_FIELDS_REQUIRED);
    }
  };

  return (
    <div className="w-full my-5">
      {error !== null && (
        <div className="flex justify-center items-center flex-col px-2 ">
          <div className="bg-red-600/30 w-full max-w-[420px] flex  px-2 py-4 rounded-md mb-4 items-center">
            <MdErrorOutline className="text-white w-5 h-5 mr-3" />
            <p className="text-sm p-0 max-w-[90%]">{error}</p>
          </div>
        </div>
      )}
      {/* confirm text */}
      <div className="flex justify-center items-center flex-col px-2">
        <div className=" w-full flex max-w-[420px] p-1 rounded-md mb-0 items-center">
          <p className="text-sm leading-6 text-zinc-400">
            {constants.DELETE_CONFIRM}{" "}
            <span className="font-bold text-zinc-50 font-mono">{name}</span>
          </p>
        </div>
      </div>
      <div className="flex justify-center items-center flex-col px-2">
        {/* group name */}
        <div className="w-full max-w-[420px] ">
          <input
            type="text"
            name="name"
            value={bookmarkName}
            placeholder={name}
            onChange={handleChange}
            className="w-full h-[50px] rounded-md px-2 text-base font-medium font-mono tracking-wide bg-transparent border border-dashed border-zinc-700 focus:border-zinc-400 focus:outline-none"
          />
        </div>
      </div>
      <div className="flex justify-end gap-4 mt-5 px-4">
        <button
          onClick={handleClose}
          disabled={isModalLoading}
          className={cn(
           secondaryButton,
            isModalLoading && "cursor-not-allowed"
          )}
        >
          Close
        </button>
        <button
          onClick={
            !isModalLoading || name === bookmarkName ? handleSubmit : () => {}
          }
          disabled={isModalLoading || name !== bookmarkName}
          className={cn(
            "bg-red-600 hover:bg-red-700 transition-all ease-in-out duration-200 max-[350px]:min-w-full max-w-[150px] h-[48px] w-[120px] flex items-center justify-center my-2 border border-transparent text-white rounded-md text-base font-mono font-semibold",
            (isModalLoading || name !== bookmarkName) &&
              "cursor-not-allowed opacity-40 hover:bg-red-600"
          )}
        >
          {!isModalLoading ? (
            "Delete"
          ) : (
            <div className="w-8 h-8 border-4 border-dashed rounded-full animate-spin border-white/50" />
          )}
        </button>
      </div>
    </div>
  );
};

const CreateAndEditBookmark = ({
  groupName,
  groupId,
  name = "",
  link = "",
  id = "",
  handleClose,
  handleCreateAndEdit,
  action,
  setError,
  error,
  isModalLoading,
  groups = [],
}) => {
  const [bookmark, setBookmark] = useState({
    name: name || "",
    link: link || "",
  });
  const [selectedGroupId, setSelectedGroupId] = useState(groupId || "");

  const handleChange = (e) => {
    error !== null && setError(null);
    setBookmark((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleGroupChange = (e) => {
    error !== null && setError(null);
    setSelectedGroupId(e.target.value);
  };

  const handleSubmit = () => {
    if (bookmark.name.trim() !== "" && bookmark.link.trim() !== "" && selectedGroupId) {
      const formattedUrl = formatUrl(bookmark.link);
      handleCreateAndEdit(action, bookmark.name, formattedUrl, selectedGroupId, id);
    } else {
      setError(constants.ALL_FIELDS_REQUIRED);
    }
  };

  return (
    <div className="w-full my-5">
      {error !== null && (
        <div className="flex justify-center space-y-5 md:space-y-0 md:space-x-5 md:items-start items-center flex-col px-2 ">
          <div className="bg-red-600/30 w-full flex max-w-[420px] md:max-w-full px-2 py-4 rounded-md mb-4 items-center">
            <MdErrorOutline className="text-white w-5 h-5 mr-3" />
            <p className="text-sm p-0 max-w-[90%]">{error}</p>
          </div>
        </div>
      )}
      <div className="flex flex-col justify-center items-center gap-3 px-4">
        {/* group selection */}
        <div className="flex-shrink-0 w-full">
          <CustomSelect
            value={selectedGroupId}
            onChange={handleGroupChange}
            placeholder="Select Group"
            options={groups.map((group) => ({
              value: group.id,
              label: group.name
            }))}
            className="w-full"
          />
        </div>
        {/* name */}
        <div className="flex-1 w-full">
          <input
            type="text"
            name="name"
            value={bookmark?.name}
            onChange={handleChange}
            placeholder="Bookmark Name"
            className="w-full h-[50px] rounded-md px-2 text-sm font-medium font-mono tracking-wide bg-transparent border border-dashed border-zinc-700 focus:border-zinc-400 focus:outline-none"
          />
        </div>
        {/* link */}
        <div className="flex-1 w-full">
          <input
            type="url"
            name="link"
            value={bookmark?.link}
            onChange={handleChange}
            placeholder="Link"
            className="w-full h-[50px] rounded-md px-2 text-sm font-medium font-mono tracking-wide bg-transparent border border-dashed border-zinc-700 focus:border-zinc-400 focus:outline-none"
          />
        </div>
      </div>
      <div className="flex gap-4 justify-end mx-auto flex-wrap mt-5 px-4">
        <button
          onClick={handleClose}
          disabled={isModalLoading}
          className={cn(
            secondaryButton,
            isModalLoading && "cursor-not-allowed"
          )}
        >
          Close
        </button>
        <button
          onClick={!isModalLoading ? handleSubmit : () => {}}
          disabled={isModalLoading}
          className={cn(primaryButton, isModalLoading && "cursor-not-allowed")}
        >
          {!isModalLoading ? (
            action === constants.ACTION_EDIT_ITEM ? (
              "Update"
            ) : (
              "Create"
            )
          ) : (
            <div className="w-8 h-8 border-4 border-dashed rounded-full animate-spin border-white/50" />
          )}
        </button>
      </div>
    </div>
  );
};

const CreateAndEditGroupName = ({
  groupId,
  title = "",
  handleClose,
  handleCreateAndEditGroupName,
  action,
  setError,
  error,
  isModalLoading,
}) => {
  const [groupName, setGroupName] = useState(title);

  const handleChange = (e) => {
    error !== null && setError(null);
    setGroupName(e.target.value);
  };

  const handleSubmit = () => {
    setError(null);
    if (groupName.trim() !== "") {
      if (groupName.trim() === title) {
        handleClose();
      } else {
        handleCreateAndEditGroupName(action, groupId, groupName);
      }
    } else {
      setError(constants.ALL_FIELDS_REQUIRED);
    }
  };

  return (
    <div className="w-full  my-5">
      {error !== null && (
        <div className="flex justify-center items-center flex-col px-2 ">
          <div className="bg-red-600/30 w-full max-w-[420px] flex  px-2 py-4 rounded-md mb-4 items-center">
            <MdErrorOutline className="text-white w-5 h-5 mr-3" />
            <p className="text-sm p-0 max-w-[90%]">{error}</p>
          </div>
        </div>
      )}

      <div className="flex justify-center items-center flex-col px-2">
        {/* group name */}
        <div className="w-full max-w-[420px] ">
          <input
            type="text"
            name="name"
            value={groupName}
            placeholder="Group Name"
            onChange={handleChange}
            className="w-full h-[50px] rounded-md px-2 text-base font-medium font-mono tracking-wide bg-transparent border border-dashed border-zinc-700 focus:border-zinc-400 focus:outline-none"
          />
        </div>
      </div>
      <div className="flex justify-end gap-4 mt-5 px-4">
        <button
          onClick={handleClose}
          disabled={isModalLoading}
          className={cn(
            secondaryButton,
            isModalLoading && "cursor-not-allowed"
          )}
        >
          Close
        </button>
        <button
          onClick={!isModalLoading ? handleSubmit : () => {}}
          disabled={isModalLoading}
          className={cn(
            primaryButton,
            isModalLoading && "cursor-not-allowed opacity-40"
          )}
        >
          {!isModalLoading ? (
            action === constants.ACTION_EDIT_GROUP_NAME ? (
              "Update"
            ) : (
              "Create"
            )
          ) : (
            <div className="w-8 h-8 border-4 border-dashed rounded-full animate-spin border-white/50" />
          )}
        </button>
      </div>
    </div>
  );
};

const DeleteGroupConfirmation = ({
  groupId,
  groupName = "",
  handleClose,
  handleDeleteGroup,
  action,
  setError,
  error,
  isModalLoading,
}) => {
  const [confirmGroupName, setConfirmGroupName] = useState("");

  const handleChange = (e) => {
    error !== null && setError(null);
    setConfirmGroupName(e.target.value);
  };

  const handleSubmit = () => {
    setError(null);
    if (confirmGroupName.trim() !== "" && confirmGroupName.trim() === groupName) {
      handleDeleteGroup(action, groupId);
    } else {
      setError(constants.ALL_FIELDS_REQUIRED);
    }
  };

  return (
    <div className="w-full my-5">
      {error !== null && (
        <div className="flex justify-center items-center flex-col px-2 ">
          <div className="bg-red-600/30 w-full max-w-[420px] flex  px-2 py-4 rounded-md mb-4 items-center">
            <MdErrorOutline className="text-white w-5 h-5 mr-3" />
            <p className="text-sm p-0 max-w-[90%]">{error}</p>
          </div>
        </div>
      )}
      {/* confirm text */}
      <div className="flex justify-center items-center flex-col px-2">
        <div className=" w-full flex max-w-[420px] p-1 rounded-md mb-0 items-center">
          <p className="text-sm leading-6 text-zinc-400">
            Confirm you want to delete this group by typing its name:{" "}
            <span className="font-bold text-zinc-50 font-mono">{groupName}</span>
          </p>
        </div>
      </div>
      <div className="flex justify-center items-center flex-col px-2">
        {/* group name */}
        <div className="w-full max-w-[420px] ">
          <input
            type="text"
            name="name"
            value={confirmGroupName}
            placeholder={groupName}
            onChange={handleChange}
            className="w-full h-[50px] rounded-md px-2 text-base font-medium font-mono tracking-wide bg-transparent border border-dashed border-zinc-700 focus:border-zinc-400 focus:outline-none"
          />
        </div>
      </div>
      <div className="flex justify-end gap-4 mt-5 px-4">
        <button
          onClick={handleClose}
          disabled={isModalLoading}
          className={cn(
           secondaryButton,
            isModalLoading && "cursor-not-allowed"
          )}
        >
          Close
        </button>
        <button
          onClick={
            !isModalLoading || groupName === confirmGroupName ? handleSubmit : () => {}
          }
          disabled={isModalLoading || groupName !== confirmGroupName}
          className={cn(
            "bg-red-600 hover:bg-red-700 transition-all ease-in-out duration-200 max-[350px]:min-w-full max-w-[150px] h-[48px] w-[120px] flex items-center justify-center my-2 border border-transparent text-white rounded-md text-base font-mono font-semibold",
            (isModalLoading || groupName !== confirmGroupName) &&
              "cursor-not-allowed opacity-40 hover:bg-red-600"
          )}
        >
          {!isModalLoading ? (
            "Delete"
          ) : (
            <div className="w-8 h-8 border-4 border-dashed rounded-full animate-spin border-white/50" />
          )}
        </button>
      </div>
    </div>
  );
};